import { render, staticRenderFns } from "./EditVlan.vue?vue&type=template&id=437840d8&scoped=true"
import script from "./EditVlan.vue?vue&type=script&lang=js"
export * from "./EditVlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437840d8",
  null
  
)

export default component.exports